import React from "react";

const map = {
  success: "success",
  completed: "success",
  active: "success",
  paid: "success",
  online: "success",
  resolved: "success",
  verified: "success",
  pending: "warning",
  warning: "warning",
  degraded: "warning",
  suspended: "warning",
  in_progress: "warning",
  callback_scheduled: "warning",
  failed: "danger",
  offline: "danger",
  banned: "danger",
  cancelled: "danger",
  refunded: "info",
  open: "primary",
  issued: "primary",
  escalated: "danger",
  urgent: "danger",
  high: "warning",
  answered: "success",
  missed: "danger",
  voicemail: "warning",
};

const StatusBadge = ({ status, label }) => {
  const key = (status || label || "").toLowerCase().replace(/\s+/g, "_");
  const variant = map[key] || "secondary";
  return <span className={`billr-badge ${variant}`}>{label || status}</span>;
};

export default StatusBadge;
